module.exports = __webpack_public_path__ + "img/kppz2.02a11dc1.png";